<div style="display: flex;flex-flow: column;height: 100%; width: 100%; gap: 30px;padding-top: 2.5rem !important;"  class="flex flex-col h-full">
    <!-- <div class="pl-20 pr-20 menu-top justify-between flex items-center flex-row text-white">
        <div class="menu-top-sub flex flex-row">
            <h2 class="text-center cursor-pointer">Request</h2>
            <h2 class="text-center cursor-pointer">Payment</h2>
            <h2 class="text-center cursor-pointer">Print</h2>
            <h2 class="text-center cursor-pointer">Configuration</h2>
        </div>


        <div>
            <h2 class="text-center cursor-pointer">Master bank account</h2>
        </div>
    </div> -->
    
    <!-- <app-head-o2></app-head-o2> -->
    <div class="menu justify-between flex items-stretch flex-row gap-5 px-20">
        <div class="gap-2.5 flex flex-row">
            <button mat-raised-button color="accent" *ngIf="checkButton('BT095')" (click)="addAccount($event)">
                <div class="flex items-center">
                    <span>Add Account</span>
                </div>
            </button>
            <button mat-raised-button color="warn" *ngIf="checkButton('BT096')" (click)="deleteAccount()">
                <div class="flex items-center">
                    <span>Delete Account</span>
                </div>
            </button>
        </div>
        <div style="flex: 1;" class="gap-2.5 flex justify-end flex-row">
            <!-- <div class="justify-evenly flex gap-2.5" style="flex: 0 40%;">
                    <h4>Showing</h4>
                    <mat-form-field style="flex-flow: row;flex: 1" class="flex">
                        <mat-select [(ngModel)]="BenefitTargetValue" name="BenefitTargetValue"
                            (selectionChange)="selectionPercent()">
                            <mat-option *ngFor="let percent of BenefitTarget" [value]="percent.benefitTargetCode">
                                {{percent.benefitTargetTName}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div> -->
            <div class="justify-evenly flex gap-2.5 items-center flex-row gap-0" style="flex: 0 40%;">
                <mat-form-field style="flex: 1" class="my-form-field flex flex-row">
                    <input autocomplete="off" type="text" matInput placeholder="คำค้นหา" matInput #input
                        [(ngModel)]="form.search" name="search" #search="ngModel" (keyup)="applyFilter($event)">
                </mat-form-field>
            </div>
            <button mat-raised-button color="accent" [matMenuTriggerFor]="menu">
                <div class="flex items-center">
                    <span>เงื่อนไขการค้นหา</span>
                    <mat-icon>expand_more</mat-icon>
                </div>
            </button>
            <mat-menu #menu="matMenu" xPosition="before" class="my-menu">
                <div class="pl-2 pr-2 gap-4 flex flex-col" (click)="stopPropagation($event)">
                    <div class="justify-evenly flex gap-2.5 items-center flex-row">
                        <mat-form-field style="flex: 1" class="my-form-field flex flex-row">
                            <mat-label>Account No. | เลขที่บัญชี</mat-label>
                            <input autocomplete="off" type="text" matInput placeholder="เลขที่บัญชี" matInput #input
                                [(ngModel)]="form.bankAccountNo" name="bankAccountNo" #bankAccountNo="ngModel">
                        </mat-form-field>
                        <mat-form-field style="flex: 1" class="my-form-field flex flex-row">
                            <mat-label>Account Name. | ชื่อบัญชี</mat-label>
                            <input autocomplete="off" type="text" matInput placeholder="ชื่อบัญชี" matInput #input
                                [(ngModel)]="form.bankAccountName" name="bankAccountName" #bankAccountName="ngModel">
                        </mat-form-field>
                    </div>
                    <div class="justify-evenly flex gap-2.5 items-center flex-row gap-0">
                        <mat-form-field style="flex: 1" class="my-form-field flex flex-row">
                            <mat-label>Tax No. | เลขที่ใบกำกับ</mat-label>
                            <input autocomplete="off" type="text" matInput placeholder="เลขที่ใบกำกับ" matInput #input
                                [(ngModel)]="form.accTaxNo" name="accTaxNo" #accTaxNo="ngModel">
                        </mat-form-field>
                    </div>
                    <div class="justify-evenly flex gap-2.5 justify-end items-center flex-row gap-0"
                        >
                        <mat-form-field style="flex: 1" class="my-form-field flex flex-row">
                            <mat-label>Status | สถานะ</mat-label>
                            <mat-select [(ngModel)]="form.isActive" name="isActive" #isActive="ngModel">
                                <mat-option value="Y">ใช้งาน</mat-option>
                                <mat-option value="N">ไม่ใช้งาน</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="justify-evenly flex gap-2.5 justify-end items-center flex-row gap-0">
                        <button mat-raised-button color="accent" (click)="loadData()"
                            >ค้นหา</button>
                    </div>
                </div>
            </mat-menu>
        </div>

    </div>
    <!-- </div> -->
    <div class="mat-elevation-z8 overflow-scroll">
        <table mat-table matSort [dataSource]="dataSource" (matSortChange)="announceSortChange($event)">
            <ng-container matColumnDef="select">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center">
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                        Select
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="text-center">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>
            <!-- Position Column -->
            <ng-container matColumnDef="bankCode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                    class="text-center"> Bank Code
                </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.bankCode}} </td>
            </ng-container>

            <!-- bankAccountNo Column -->
            <ng-container matColumnDef="bankAccountNo">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center"> Account no. </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.bankAccountNo}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="bankAccountName">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center"> Account name </th>
                <td mat-cell *matCellDef="let element" class="text-left"> {{element.bankAccountName}} </td>
            </ng-container>

            <ng-container matColumnDef="accTaxNo">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center"> TAX NO </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.accTaxNo}} </td>
            </ng-container>


            <ng-container matColumnDef="isBotAcc">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center"> Enabled </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    {{element.isActive == 'Y' ? 'ใช้งาน' : 'ไม่ใช้งาน'}} </td>
            </ng-container>


            <!-- Symbol Column -->
            <ng-container matColumnDef="bankBranch">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-center"> Branch </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.bankBranch}} </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Action </th>
                <td mat-cell *matCellDef="let element;let i = index" class="text-center">
                    <button mat-icon-button matTooltip="รายละเอียด" *ngIf="checkButton('BT097')" (click)="editItem(element)">
                        <mat-icon svgIcon="heroicons_outline:pencil-alt"></mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="ลบ" *ngIf="checkButton('BT096')" (click)="delete(element)" matTooltipPosition="above">
                        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons
            aria-label="Select page of periodic elements">
        </mat-paginator>
    </div>
</div>